import React from 'react';
import { Container, Header, Divider } from 'semantic-ui-react';


class Strategy extends React.Component{
  render(){
    return <Container text textAlign='left'>
      <Header as='h3' textAlign='center'>
      Investment Strategy
    </Header>
    <Divider/>
    <Container textAlign='left'>
    <p>
      OVC is an important resource to university-related startups in terms of scientific and
      commercial peer review. It draws on the expertise from its Council of Experts as well as
      market knowledge from industry experts in the US and Asia. In addition to providing
      strategic business advice, OVC performs a credible and independent function in terms
      of obtaining external sources of funding and commercial applications. Portfolio
      companies can rely on OVC for an independent market valuation and funding source.
    </p>
    </Container>
    </Container>;
  }
}

export default Strategy;
